import React from "react";
import "./index.less";
import {useTranslation} from "react-i18next";

export default function Products() {
    const { t } = useTranslation();

    const products = [
        {
            name: t('product.highSpeedDisperser'),
            tips: t('product.customizable'),
            params: t('product.highSpeedDisperserParams'),
            img: 'http://47.115.148.248:9000/officeweb/product/fen_san_ji.jpg'
        },
        {
            name: t('product.mixerProductionLine'),
            tips: t('product.customizable'),
            params: t('product.mixerProductionLineParams'),
            img: 'http://47.115.148.248:9000/officeweb/product/hun_liao_ji.png'
        },
        {
            name: t('product.chiliShearing'),
            tips: t('product.customizable'),
            params: t('product.chiliShearingParams'),
            img: 'http://47.115.148.248:9000/officeweb/product/la_jiao_jian_ti_ji.jpg'
        },
        {
            name: t('product.wallPanelInstaller'),
            tips: t('product.customizable'),
            params: t('product.wallPanelInstallerParams'),
            img: 'http://47.115.148.248:9000/officeweb/product/qiang_ban_an_zhuang_ji.jpg'
        },
        {
            name: t('product.portableCuttingSaw'),
            tips: t('product.customizable'),
            params: t('product.portableCuttingSawParams'),
            img: 'http://47.115.148.248:9000/officeweb/product/qie_ge_ju.jpg'
        },
        {
            name: t('product.suctionCupInstaller'),
            tips: t('product.customizable'),
            params: t('product.suctionCupInstallerParams'),
            img: 'http://47.115.148.248:9000/officeweb/product/xi_pan_an_zhuang_ji.jpg'
        },
        {
            name: t('product.inclinedPalletTruck'),
            tips: t('product.customizable'),
            params: t('product.inclinedPalletTruckParams'),
            img: 'http://47.115.148.248:9000/officeweb/product/yun_shu_che_ji.jpg'
        },
        {
            name: t('product.stonePaintMixer'),
            tips: t('product.customizable'),
            params: t('product.stonePaintMixerParams'),
            img: 'http://47.115.148.248:9000/officeweb/product/zheng_shi_jiao_ban_ji.jpg'
        }
    ];

    return (
        <div className="products-page">
            <div className="products-hero">
                <div className="hero-bg"></div>
                <div className="hero-content">
                    <span className="hero-badge">{t('product.badge')}</span>
                    <h1 className="hero-title">{t('product.title')}</h1>
                    <p className="hero-subtitle">{t('product.subtitle')}</p>
                </div>
            </div>

            <div className="products-section">
                <div className="section-container">
                    <div className="products-grid">
                        {products.map((item, index) => (
                            <div className="product-card" key={index}>
                                <div className="card-inner">
                                    <div className="card-image">
                                        <img src={item.img} alt={item.name}/>
                                        <div className="card-overlay">
                                            <a href={`https://wa.me/8615716377150?text=${encodeURIComponent(t('product.whatsappMessage') + item.name)}`}
                                               target="_blank" rel="noopener noreferrer" className="contact-btn">
                                                <span className="btn-icon">
                                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                                                    </svg>
                                                </span>
                                                {t('product.contactUs')}
                                            </a>
                                        </div>
                                    </div>
                                    <div className="card-content">
                                        <h3 className="card-title">{item.name}</h3>
                                        <p className="card-params">
                                            <span className="params-icon">
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                                                </svg>
                                            </span>
                                            {item.params}
                                        </p>
                                        <p className="card-tips">{item.tips}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="cta-section">
                <div className="cta-bg"></div>
                <div className="cta-content">
                    <h2 className="cta-title">{t('product.ctaTitle')}</h2>
                    <p className="cta-subtitle">{t('product.ctaSubtitle')}</p>
                    <div className="cta-buttons">
                        <a href="https://wa.me/8618303951089" target="_blank" rel="noopener noreferrer" className="cta-primary-btn">
                            {t('product.getQuote')}
                        </a>
                        <a href="/about" className="cta-secondary-btn">
                            {t('product.learnMore')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
